import joinClasses from "helpers/joinClasses";
import Button from ".";

export function SecondaryButton({ className, children, onClick, ...props }) {
  return (
    <Button
      className={joinClasses(
        "bg-primary text-white !font-raleway-bold",
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </Button>
  );
}
